<mg-points-rewards-list></mg-points-rewards-list>
